
import { Component, Prop, Vue } from 'vue-property-decorator';
import Avatar from '@/components/common/avatar/Avatar.vue';
import { ProjectManager } from '@/models';

import ManagerListPopup from './manager-list-popup/ManagerListPopup.vue';

@Component({
  components: {
    Avatar,
    ManagerListPopup
  }
})
export default class ProjectManagerInformation extends Vue {
  @Prop({ type: Array, required: true })
  managers!: ProjectManager[];

  dialog = false;

  get displayMembers(): ProjectManager[] {
    return (this.managers || []).slice(0, 4);
  }

  get numberOfNotDisplayMembers(): number {
    return (this.managers || []).length - 4;
  }

  onClickAvatar(): void {
    this.dialog = true;
  }
}
